import {Observable, tap} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AceLoggerService} from '@logging/ace-logger.service';
import {AceLogger} from '@logging/ace-logger';
import {FrontendConfig} from '../api/dashboard-config.interface';
import {BaseService} from '../api/base-service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends BaseService {

  private readonly logger: AceLogger;
  private config: FrontendConfig;

  constructor(private http: HttpClient, logService: AceLoggerService) {
    super();
    this.logger = logService.create(ConfigService.name);
  }

  public fetchAndCacheConfig(): Observable<FrontendConfig> {
    const url = this.getConfigUrl() + '/config.json?_=' + Date.now();
    return this.http.get<FrontendConfig>(url).pipe(tap(response => {
      if (response) {
        this.config = response;
      } else {
        throw new Error('Invalid config ' + JSON.stringify(response));
      }
    }));
  }

  public getCachedConfig(): FrontendConfig {
    return this.config;
  }
}
